export default __webpack_public_path__ + "locales/vi/DeleteSelfProfileDialog.json?hash=12d0e3d6e4d6e019ddc1271882b8f98c";